var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pos-app-wrapper flex flex-col fixed w-screen h-screen"},[_c('router-view'),_c('Ajax'),_c('v-dialog',{attrs:{"min-width":600,"width":600,"min-height":400}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }